import { createAction } from '@reduxjs/toolkit'
import { BimObject, BimViewMode } from '../models/Bim'

export const setBimObjects = createAction<BimObject[]>('bim/setBimObjects')
export const addBimObjects = createAction<BimObject[]>('bim/addBimObjects')
export const setSelectedBimObjectId = createAction<string | null>(
  'bim/setSelectedBimObjectId',
)
export const changeViewMode = createAction<BimViewMode>('bim/changeViewMode')
export const resetBimState = createAction('bim/resetBimState')
